@if (this.loading()) {
  <div class="h-[180px]">
    <div class="spinner m-auto mt-20 h-32 w-32 border-8"></div>
  </div>
} @else {
  @if (ref.data?.isCurrentQuarterSelected) {
    <div class="mb-2">Notes</div>
    <aux-input
      id="notes"
      class="w-full text-xs"
      placeholder="Please enter notes here…"
      [inAppBudgetStyle]="true"
      [textArea]="true"
      resize="none"
      [(ngModel)]="notes"
    />
  }

  <div class="mb-2 mt-4">Filter by month</div>
  <ng-select
    class=""
    [multiple]="false"
    [clearable]="false"
    [formControl]="monthFilterControl"
    appendTo="body"
  >
    @for (month of monthOptions; track month.value) {
      <ng-option [value]="month.value">
        {{ month.label }}
      </ng-option>
    }
  </ng-select>

  <div class="mt-5 max-h-[225px] overflow-y-auto">
    @for (
      month of filteredNoteList;
      track month.month;
      let first = $first;
      let monthIndex = $index
    ) {
      <div
        [ngClass]="{
          'border-t border-aux-gray-dark pt-5': !first,
        }"
      >
        <div class="mb-[10px] flex items-center font-bold">
          {{ month.label }}

          <aux-badge
            [title]="month.items.length.toString()"
            variant="blue"
            className="ml-2 leading-[16px] text-[12px]"
          />
        </div>

        @if (month.items.length > 0) {
          @for (note of month.items; track note.id) {
            <div class="mb-4 flex border-l-[2px] border-aux-blue-light pl-3">
              <div class="grow">
                <div class="italic opacity-75">
                  {{ note.username }} - {{ note.create_date | date: 'MMM d, YYYY' }}:
                </div>
                <div
                  #text
                  class="note-truncate-text"
                  auxTooltip
                  [template]="text.offsetHeight < text.scrollHeight ? tooltip : undefined"
                >
                  {{ note.message }}
                </div>

                <ng-template #tooltip>
                  <p class="max-w-[600px] break-words">
                    {{ note.message }}
                  </p>
                </ng-template>
              </div>

              <div class="pr-[5px]">
                <button
                  class="btn h-6 w-6 rounded-full border-0 p-0 shadow-none"
                  type="button"
                  (click)="removeNote(note, monthIndex)"
                  [ngClass]="{
                    'cursor-not-allowed opacity-50': !note.removable,
                  }"
                  [disabled]="!note.removable"
                  [auxTooltip]="
                    note.removable
                      ? ''
                      : 'You can only delete your own notes for the current open month.'
                  "
                >
                  <aux-icon name="Trash" class="text-aux-error" />
                </button>
              </div>
            </div>
          }
        } @else {
          <div class="mb-4 border-l-[2px] border-aux-blue-light pl-3 italic opacity-75">
            No Notes
          </div>
        }
      </div>
    }
  </div>
}
